import { render, staticRenderFns } from "./dwsPaylief.vue?vue&type=template&id=098bc64f&scoped=true"
import script from "./dwsPaylief.vue?vue&type=script&lang=js"
export * from "./dwsPaylief.vue?vue&type=script&lang=js"
import style0 from "./dwsPaylief.vue?vue&type=style&index=0&id=098bc64f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bc64f",
  null
  
)

export default component.exports